export const RestoreRoute = {
  FORGOT_PASSWORD: '/restore/password',
  CHANGE_PASSWORD: '/change/password',
}